import {AccountDetailDto, AccountDto} from 'Agent/Accounts/api';
import {Link, PolicyDetailDto} from 'Agent/Policies/api';

export enum DataSourceFlag {
  EIS = 'eisFlag',
}

export enum DataSource {
  LEGACY,
  EIS,
}

export const getEisFlagFromLinks = (links?: Link[]) => {
  const params = new URLSearchParams((links?.[0]?.href ?? '').split('?')[1]);
  return params.has(DataSourceFlag.EIS) && params.get(DataSourceFlag.EIS) === 'true'
    ? String(DataSource.EIS)
    : String(DataSource.LEGACY);
};

export const getEisGroupNumberFromLinks = (account: AccountDto) => {
  const params = new URLSearchParams((account.links?.[0]?.href ?? '').split('?')[1]);
  if (params.has(DataSourceFlag.EIS) && params.get(DataSourceFlag.EIS) === 'true') {
    return account.groupNumber;
  }
  return '';
};

export const getEisProductCdFromLinks = (account: AccountDto) => {
  const params = new URLSearchParams((account.links?.[0]?.href ?? '').split('?')[1]);
  if (params.has(DataSourceFlag.EIS) && params.get(DataSourceFlag.EIS) === 'true') {
    return account.policyNumber;
  }
  return '';
};

type DetailDtoType = PolicyDetailDto | AccountDetailDto;

export const hasEisFlag = (data: DetailDtoType) => {
  return data?.eisFlag ? String(DataSource.EIS) : String(DataSource.LEGACY);
};
